<template>
  <div v-if="messages" class="change-site-version">
    <ModalComponentHeader> {{ messages?.welcome }} </ModalComponentHeader>
    <ModalComponentBody>
      <p class="change-site-version-text">
        {{ messages?.wannaChooseVersion }}
      </p>
      <DefButtonSecondary :href="siteSettings?.switchVersionLink">{{
        messages?.switchVersion
      }}</DefButtonSecondary>
      <DefButtonPrimary @click="stayCurrentVersion">{{
        messages?.stayOnCurrentVersion
      }}</DefButtonPrimary>
    </ModalComponentBody>
  </div>
</template>

<script lang="ts" setup>
import ModalComponentHeader from '@use/useModal/ModalComponentHeader.vue';
import ModalComponentBody from '@use/useModal/ModalComponentBody.vue';
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import DefButtonSecondary from '@components/Def/DefButtonSecondary/DefButtonSecondary.vue';
import { computed, onBeforeUnmount } from 'vue';
import useModal from '@use/useModal/useModal';
import DeliveryCountryModal from '@components/Header/DeliveryCountry/DeliveryCountryModal.vue';
import { setCookie } from '@/utils/cookies';
import { useResultsStore } from '@/storePinia/stores/results';

const modal = useModal();
const resultsStore = useResultsStore();
const siteSettings = computed(() => resultsStore.siteSettings);
const messages = computed(() => resultsStore.siteSettings?.messages);

const countriesList = computed(() => resultsStore.deliveryCountries?.items);
const getCurrentDeliveryCountry = computed(() =>
  countriesList?.value?.find((el) => el.isUserCountry)
);

const stayCurrentVersion = () => {
  modal.hide();
  if (siteSettings.value?.isGlobalVersion && !getCurrentDeliveryCountry.value) {
    modal.show(DeliveryCountryModal, {}, { width: '696px' });
  }
};
onBeforeUnmount(() => {
  setCookie('WebsiteVersionModalShowed', 'true');
});
</script>

<style lang="scss" scoped>
.change-site-version {
  text-align: center;
  :deep(.modal-component-body) {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
  }
  :deep(.def-button-secondary) {
    margin-bottom: 12px;
  }
}
.change-site-version-text {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%;
  margin-bottom: 16px;
  color: var(--color-dark-grey);
}
</style>
